import { Target } from "lucide-react";
import type { ModuleSpec } from "../types";

export const customerSegmentsSpec: ModuleSpec = {
  id: "customer-segments",
  icon: Target,
  i18n: {
    namespace: "modules",
    titleKey: "customer-segments.title",
    descriptionKey: "customer-segments.description",
  },
  nav: {
    path: "/customers/segments",
    group: "observe",
    order: 20,
    subgroup: "cdp",
  },
  permission: {
    action: "read",
    subject: "cdp",
  },
  meta: {
    status: "active",
    description: "Create and manage customer segments",
  },
};
